<template>
   <div class="boxbranco listagem-container mt-2">
        <titulo classeAwesome="fa fa-file-text-o" nome="Taxa de Ocupação - Meia Noite" />

        <div class="row">

            <div class="form-group col-md-4">
                    <label for="unidade">Unidade</label>
                    <multiselect
                        :options="meianoite.unidades"
                        track-by="nomeUnidade"
                        label="nomeUnidade"
                        :searchable="true"
                        placeholder="Selecione (se vazio, todas são listadas)"
                        selectLabel="+"
                        deselectLabel="-" 
                        selectedLabel="selecionado"
                        v-model="unidade"
                        >

                        <span slot="noResult">Nenhum resultado encontrado.</span>
                    </multiselect>
                </div>

            <div class="col-md-3 form-group">
                <label>De</label>
                <datepicker
                    v-model="dataInicial"
                    :format="formatoData"
                    :disabled="dateDisabled"
                    language="pt-br"
                    id="data-pickerinicio"
                    calendar-button
                    calendar-button-icon="fa fa-calendar"
                    >
                </datepicker>
            </div>

            <div class="col-md-3 form-group">
                <label>Até</label>
                <datepicker
                    v-model="dataFinal"
                    :format="formatoData"
                    :disabled="dateDisabled"
                    language="pt-br"
                    id="data-picker"
                    calendar-button
                    calendar-button-icon="fa fa-calendar"
                    >
                </datepicker>
            </div>

            <div class="col-md-2 form-group">
                <label for="tpaih">Esfera Administrativa</label>
                <select class="form-control" v-model="esfera">
                    <option value="">Todos</option>
                    <option value="01">Federal</option>
                    <option value="02">Estadual</option>
                    <option value="03">Municipal</option>
                </select>
            </div>
        </div>

        <b-button @click="unidade = ''" variant="outline-secondary" class="mr-2">Limpar Unidade</b-button>
        <b-button @click="pesquisa" variant="primary" :disabled="rangeDatas == false ? true : false">Pesquisar</b-button>

        <div v-if="rangeDatas == false" class="alert alert-danger mt-4" role="alert">Distância entre datas permitida para pesquisa é de no máximo 6 meses</div>

    </div>
</template>

<script>
import Titulo from '../../../shared/titulo/Titulo.vue'
import Datepicker from 'vuejs-datepicker'
import moment from "moment"

export default {
    components: {
        Titulo,
        Datepicker,
    },
    mounted () {
        this.$store.dispatch('relatorios/pegaUnidadesMeianoite')
    },
    computed: {
        meianoite () {
            return this.$store.getters['relatorios/getMeianoite']
        },
        rangeDatas () {
            let de = this.dataInicial.getTime()
            let ate = this.dataFinal.getTime()
            
            let dias = 86400000 * 182;
            let diferenca = ate - de;

            if (diferenca > dias) return false
            else true
        }
    },
    data () {
        return {
            formatoData: 'dd/MM/yyyy',
            dateDisabled: {
                from: new Date(),
            },
            unidade: '',
            dataInicial: new Date(),
            dataFinal: new Date(),
            esfera: ''
        }
    },
    watch: {
        unidade (value) {
            this.$emit('mudaUnidade', value)
            this.$store.commit('relatorios/setTaxaOcupacaoMeianoite', null)
        },
        dataInicial (value) {
            this.$store.commit('relatorios/setTaxaOcupacaoMeianoite', null)
        },
        dataFinal (value) {
            this.$store.commit('relatorios/setTaxaOcupacaoMeianoite', null)
        },
        esfera (value) {
            this.$emit('mudaEsfera', value)
        }
    },
    methods: {
        formatadata (date) {
            return moment(date).format("YYYY-MM-DD")
        },
        pesquisa () {
            this.unidade == '' || !this.unidade
                ? this.$store.dispatch('relatorios/listaTaxaOcupacaoMeianoite', {dataInicial: this.formatadata(this.dataInicial), dataFinal: this.formatadata(this.dataFinal)})
                : this.$store.dispatch('relatorios/listaTaxaOcupacaoUnidadeMeianoite', {dataInicial: this.formatadata(this.dataInicial), dataFinal: this.formatadata(this.dataFinal), cnes: this.unidade.cnesUnidade})
        }
    }
}
</script>
